<template>
    <div class="wechat-marketing">
        <div class="header">
            <div class="left">
                <label>可面向公众号粉丝主动营销群发消息</label>
                <label>支持即时群发和定时群发</label>
            </div>
            <div class="right">
                <el-button type="primary" @click="openModel(false)">新增即时群发</el-button>
                <el-button type="warning" @click="openModel(true)">新增定时群发</el-button>
            </div>
        </div>
        <div class="search-panel">
            <label v-if="weChatList.length>1">公众号名称</label>
            <el-select v-model="subscriptionId" placeholder="请选择公众号" v-if="weChatList.length>1">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="item in weChatList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <label>消息类型</label>
            <el-select v-model="type" placeholder="请选择消息类型">
                <el-option label="全部" value=""></el-option>
                <el-option label="文本" value="1"></el-option>
                <el-option label="图片" value="2"></el-option>
                <el-option label="图文" value="3"></el-option>
                <el-option label="模板" value="4"></el-option>
            </el-select>
            <label>群发类型</label>
            <el-select v-model="timing" placeholder="请选择群发类型">
                <el-option label="全部" value=""></el-option>
                <el-option label="定时" :value="true"></el-option>
                <el-option label="实时" :value="false"></el-option>
            </el-select>
            <label>群发备注</label>
            <el-input placeholder="请输入群发备注" v-model="remark" @keyup.enter.native="pageChange(1)"></el-input>
            <el-button class="add" type="warning" @click="pageChange(1)">查询</el-button>
        </div>
        <div class="body">
            <div class="page-title">消息列表</div>
            <el-table :data="tableData" border class="omtable" style="width: 100%" tooltip-effect="dark">
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="appName" label="公众号名称" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column  label="消息类型" min-width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.type==1">文本</div>
                        <div v-if="scope.row.type==2">图片</div>
                        <div v-if="scope.row.type==3">图文</div>
                        <div v-if="scope.row.type==4">模板</div>
                    </template>
                </el-table-column>
                <el-table-column label="群发类型" min-width="80" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.row.timing">定时</div>
                        <div v-else>实时</div>
                    </template>
                </el-table-column>
                <el-table-column prop="addedSum" label="消息内容" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.type==1" popper-class="tooltip" effect="dark" :content="scope.row.content" placement="top">
                            <div class="line2">{{scope.row.content}}</div>
                        </el-tooltip>
                        <div v-if="scope.row.type==2">图片</div>
                        <div v-if="scope.row.type==3">图文</div>
                        <div v-if="scope.row.type==4">模板</div>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="群发备注" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="110px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateTime" label="发送时间" min-width="110px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.row.timing&&!scope.row.sendStatus">{{scope.row.timingSendTime}}</div>
                        <div v-else>{{scope.row.updateTime}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sendStatus" label="状态" width="80" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.row.sendStatus">发送成功</div>
                        <div v-else>待发送</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sendNum" label="接收人数" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" min-width="200px" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="openDetail(scope.row)">消息详情</el-button>
                        <el-button type="danger" size="small" @click="delData(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="page"  background layout="total,prev, pager, next" @current-change="pageChange" :page-size='10' :total="listCount">
            </el-pagination>
        </div>

        <el-dialog :title="form.timing?'新建定时群发':'新建即时群发'" width="666px" :visible.sync="formShow" top="5vh">
            <el-form :model="form" :inline="true" label-width="90px" ref='form' label-position="right">
                <el-form-item label="公众号" prop="subscriptionId" :rules="[rules.required('请选择公众号')]">
                    <el-select v-model="form.subscriptionId" placeholder="请选择公众号" @change="checkForm('subscriptionId')" >
                        <el-option
                            v-for="item in weChatList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="发送对象" prop="sendFansType" :rules="[rules.required('请选择发送对象')]">
                    <el-select v-model="form.sendFansType" placeholder="请选择发送对象" @change="checkForm('sendFansType')">
                        <el-option label="全部粉丝" value="1"></el-option>
                        <el-option label="有回复粉丝" value="2"></el-option>
                        <el-option label="新粉丝" value="3"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="发送时间" prop="timingSendTime" :rules="[rules.required('请选择发送时间')]" v-if="form.timing">
                    <el-date-picker v-model="form.timingSendTime" type="datetime" :picker-options="dateSetting" placeholder="请选择发送时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="消息类型" prop="type" :rules="[rules.required('请选择消息类型')]">
                    <el-select v-model="form.type" placeholder="请选择消息类型" @change="clearMedia">
                        <el-option label="文本" value="1"></el-option>
                        <el-option label="图片" value="2"></el-option>
                        <el-option label="图文" value="3"></el-option>
                        <el-option label="模板" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 文本 -->
                <el-form-item class="full" v-if="form.type==1" label="消息内容" prop="content" :rules="[rules.required('请输入消息内容')]">
                    <el-input type="textarea" placeholder="请输入消息内容" :autosize="{ minRows: 4}" v-model="form.content"></el-input>
                </el-form-item>
                <!-- 图片 -->
                <el-form-item class="full" v-if="form.type==2" label="消息内容" prop="subscriptionMediaId" :rules="[rules.required('选择图片素材')]">
                    <div class="show-box" @click="$refs.mediaModal.open(2)" v-if="mediaData.id">
                        <img :src="mediaData.url" alt="">
                    </div>
                    <div class="select-btn" @click="$refs.mediaModal.open(2)" v-else>
                        <i class="icon-jia"></i>
                        <div>选择图片素材</div>
                    </div>
                </el-form-item>
                <!-- 图文 -->
                <el-form-item class="full" v-if="form.type==3" label="消息内容" prop="subscriptionMediaId" :rules="[rules.required('选择图文素材')]">
                    <div class="article-btn" @click="$refs.mediaModal.open(1)" v-if="mediaData.id">
                        <articleDetail :item="mediaData" type="formLook"></articleDetail>
                    </div>
                    <div class="select-btn" @click="$refs.mediaModal.open(1)" v-else>
                        <i class="icon-jia"></i>
                        <div>选择图文素材</div>
                    </div>
                </el-form-item>
                <!-- 模板 -->
                <el-form-item class="full" v-if="form.type==4" label="消息内容" prop="standardTemplateId" :rules="[rules.required('选择模板素材')]">
                    <div class="article-btn" @click="$refs.mediaModal.open(3)" v-if="mediaData.id">
                        <templateDetail :item="mediaData" type="look"></templateDetail>
                    </div>
                    <div class="select-btn" @click="$refs.mediaModal.open(3)" v-else>
                        <i class="icon-jia"></i>
                        <div>选择模板素材</div>
                    </div>
                </el-form-item>
                <el-form-item class="full" label="群发备注" prop="remark">
                    <el-input type="textarea" placeholder="您可输入群发备注，记录消息用途。"
                        :autosize="{ minRows: 4}" v-model="form.remark"></el-input>
                </el-form-item>
            </el-form>
            <div class="btn-list">
                <el-button type="warning" plain @click="formShow=false">取消</el-button>
                <el-button type="warning" @click="submitForm">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="消息详情" class="detail-box" width="666px" :visible.sync="detailShow" top="5vh">
            <el-form :model="form" :inline="true" label-width="110px" ref='form' label-position="right">
                <el-form-item label="发送公众号：">
                    <div>{{detail.appName}}</div>
                </el-form-item>
                <el-form-item label="群发类型：">
                    <div v-if="detail.timing">定时</div>
                    <div v-else>实时</div>
                </el-form-item>
                <!-- <el-form-item label="发送对象：">
                    <div v-if="detail.sendFansType==1">全部粉丝</div>
                    <div v-if="detail.sendFansType==2">有回复粉丝</div>
                    <div v-if="detail.sendFansType==3">新粉丝</div>
                </el-form-item> -->
                <el-form-item label="消息类型：">
                    <div v-if="detail.type==1">文本</div>
                    <div v-if="detail.type==2">图片</div>
                    <div v-if="detail.type==3">图文</div>
                    <div v-if="detail.type==4">模板</div>
                </el-form-item>
                <el-form-item label="消息内容：" class="full">
                    <div v-if="detail.type==1">{{detail.content}}</div>
                    <div v-if="detail.type==2" class="img-box">
                        <img :src="detail.picUrl" alt="">
                    </div>
                    <div v-if="detail.type==3">
                        <articleDetail :item="detail" type="look"></articleDetail>
                    </div>
                    <div v-if="detail.type==4">
                        <templateDetail :item="detail.summary" type="look"></templateDetail>
                    </div>
                </el-form-item>
                <el-form-item label="群发备注：" class="full">
                    <div>{{detail.remark}}</div>
                </el-form-item>
                <el-form-item label="群发创建时间：" class="full">
                    <div>{{detail.createTime}}</div>
                </el-form-item>
                <el-form-item label="群发发送时间：" class="full">
                    <div v-if="detail.timing&&!detail.sendStatus">{{detail.timingSendTime}}</div>
                    <div v-else>{{detail.updateTime}}</div>
                </el-form-item>
                <el-form-item label="成功接收人数：" class="full">
                    <div>{{detail.sendNum}}</div>
                </el-form-item>
            </el-form>
        </el-dialog>
        <mediaModal ref="mediaModal" @submit="submitMedia" :subscriptionId="form.subscriptionId"></mediaModal>
    </div>
</template>
<script>
import commom from "../../api/common";
import {ruleTool} from '@/api/mixins'
import mediaModal from "./components/mediaModal";
import articleDetail from "./components/articleDetail";
import templateDetail from "./components/templateDetail";
//当前实例组件
export default {
    mixins: [ruleTool],
    data(){
        const $this = this;
        return {
        userId:"",
        subscriptionId:"",//公众号id
        remark:"",//群发备注
        type:"",//消息类型
        timing:"",//群发类型
        listCount:0,
        tableData:[],
        pageNum:1,
        weChatList:[],//公众号列表
        form:{},
        formShow:false,
        mediaData:{},
        detailShow:false,
        detail:{},
        dateSetting:{
            disabledDate(time) {
                return time.getTime()<new Date().getTime()-24*60*60*1000;
            },
        }
    }
    },
    components: {mediaModal,articleDetail,templateDetail},
    mounted() {
        this.userId = this.$tools.getLocal("userinfo").id
        this.getWeChatList(_=>{
            this.getList();
        });
    },
    methods: {
        openDetail(item){
            const data = Object.assign({}, item);
            if(data.type == 4){
                data.summary = JSON.parse(data.summary);
            }else if(data.type == 3){
                data.articles = JSON.parse(data.articles);
                if(data.articles.length){
                    data.title = data.articles[0].title;
                    data.thumb_url = data.articles[0].thumb_url;
                    data.digest = data.articles[0].digest;
                    data.url = data.articles[0].url;
                }
                console.log(data)
            }
            this.detail = data
            this.detailShow = true;
        },
        //验证单个字段
        checkForm(key){
            this.$refs.form.validateField(key)
        },
        // 提交表单
        submitForm(){
             this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$http({
                        url:'/wechatthirdplat/activeSendMessage/saveAndPush',
                        type:'post',
                        params: this.form,
                    }).then((data)=> {
                        this.$message.success('发送成功');
                        this.formShow = false;
                        this.pageChange(1);
                    })
                } else {
                    this.$message.error('请输入正确的信息');
                }
            });

        },
        // 清除选取的素材
        clearMedia(){
            this.checkForm('type');
            this.$set(this.form,'content','');
            this.$set(this.form,'subscriptionMediaId','');
            this.$set(this.form,'standardTemplateId','');
            this.mediaData={}
        },
        // 选取素材
        submitMedia(data){
            this.mediaData = data;
            this.$set(this.form,'subscriptionMediaId',data.id);
            if(this.form.type==4){
                this.$set(this.form,'standardTemplateId',data.id);
            }
        },
        // 公众号列表
        getWeChatList(callback){
            const params = {
                userId:this.userId,
                pageSize:99,
                pageNum:1
            }
            this.$http({
                url:'/wechatthirdplat/subscription/read/list',
                type:'put',
                params: params,
            }).then((data)=> {
                this.weChatList = data.data;
                if(data.data.length == 1){
                    this.subscriptionId = data.data[0].id;
                }
                callback&&callback()
            })
        },
        // 打开表单弹窗
        openModel(timing){
            this.form = {
                timing,
                userId:this.userId
            };
            this.formShow = true;
        },
        delData(item){
            this.$confirm(
                '确认删除群发消息？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            .then(()=> {
                this.$http({
                    url:'/wechatthirdplat/activeSendMessage',
                    type:'delete',
                    params: {ids:item.id},
                }).then((data)=> {
                    this.pageNum = 1;
                    this.getList();
                    this.$message.success('删除成功');
                })
            });
        },
        pageChange(page){
            this.pageNum = page;
            this.getList();
        },
        getList(){
            const params = {
                userId:this.userId,
                subscriptionId:this.subscriptionId,
                remark:this.remark,
                type:this.type,
                timing:this.timing,
                pageSize:10,
                pageNum:this.pageNum
            }
            this.$http({
                url:'/wechatthirdplat/activeSendMessage/read/customList',
                type:'post',
                params: params,
            }).then((data)=> {
                this.tableData = data.data;
                this.listCount = data.total;
            })
        }
    },
};
</script>
<style lang="scss">
@import "./marketing";
</style>
